/* ============================================================
   SIZE GUIDE — COMBINED (calculator + color chart table)
   ------------------------------------------------------------
   Engine for sections/size-guide-combined.liquid. Exposed as
   window.initSizeGuideCombined(scope) so it can be re-run after
   the size guide is injected into the size-chart x-drawer via
   AJAX (that loader strips inline <script> tags, so the payload
   lives in a <textarea class="sgc-payload"> which survives).

   Reads EITHER a full payload OR a bare matrix ({ "B": {"32":"S"} }).
   ============================================================ */
(function () {
  'use strict';

  var CHEVRON_RIGHT = '<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M16.8452 5.43475L22.8648 11.4545L23.6603 12.25L22.8648 13.0455L16.8452 19.0651L15.2541 17.4742L19.3532 13.3751H1.00049V11.1251H19.3535L15.2541 7.02574L16.8452 5.43475Z" fill="white"/></svg>';
  var CHEVRON_LEFT = '<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20.9999 11.7H6.41394L11.7069 6.40704L10.2929 4.99304L2.58594 12.7L10.2929 20.407L11.7069 18.993L6.41394 13.7H20.9999V11.7Z" fill="white"/></svg>';
  var CUP_DOWN_SVG = '<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18.707 13.407L17.293 11.993L13 16.286V6.70001H11V16.286L6.70697 11.993L5.29297 13.407L12 20.114L18.707 13.407Z" fill="#2a555a"/></svg>';

  function esc(s){ return String(s).replace(/[&<>"]/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }
  function inRange(v, min, max){ return v >= min && v <= max; }

  function initRoot(root){
    if (!root || root.dataset.sgcInited) return;
    root.dataset.sgcInited = '1';

    var DEFAULT_COLORS = {
      "XS":"#E2F4FF","S":"#FBDECC","S+":"#FFD6C8","M":"#FDF5D3","M+":"#FFE59A",
      "L":"#FFDEF2","L+":"#F9E3F1","XL":"#E2F4FF","XL+":"#EDF4FF",
      "2XL":"#F7FFEC","2XL+":"#D3F2D6","3XL":"#FED2D3","3XL+":"#FF9FD3"
    };
    var META_KEYS = ['output','bands','cups','underbust_ranges','overbust_by_band','matrix','colors','unit'];

    var payloadEl = root.querySelector('.sgc-payload');
    if (!payloadEl) return;
    var P;
    try { P = JSON.parse(payloadEl.value || payloadEl.textContent); }
    catch(e){ console.error('[size-guide-combined] invalid JSON payload', e); return; }

    /* Accept EITHER a full payload OR a bare matrix ({ "B": {"32":"S",...}, ... }).
       If there's no "matrix" key, treat the top-level cup-like keys as the matrix. */
    var matrix = P.matrix;
    if (!matrix || !Object.keys(matrix).length) {
      matrix = {};
      Object.keys(P).forEach(function(k){
        if (META_KEYS.indexOf(k) === -1 && P[k] && typeof P[k] === 'object' && !Array.isArray(P[k])) {
          matrix[k] = P[k];
        }
      });
    }

    var cups = (P.cups && P.cups.length) ? P.cups : Object.keys(matrix);

    var bands = P.bands;
    if (!bands || !bands.length) {
      var bandSet = {};
      cups.forEach(function(cup){ Object.keys(matrix[cup] || {}).forEach(function(b){ bandSet[b] = 1; }); });
      bands = Object.keys(bandSet).sort(function(a, b){ return Number(a) - Number(b); });
    }

    var colors = (P.colors && Object.keys(P.colors).length) ? P.colors : DEFAULT_COLORS;
    var underbustRanges = P.underbust_ranges || [];
    var overbustByBand = P.overbust_by_band || {};
    var output = (root.getAttribute('data-output') || P.output || 'bra');

    /* Calculator needs measurement ranges. If the JSON is table-only
       (no ranges), hide the calculator and show just the chart. */
    var hasCalc = underbustRanges.length > 0 && Object.keys(overbustByBand).length > 0;

    if (hasCalc) {
      setupCalculator();
    } else {
      var calcWrap = root.querySelector('.sc__container');
      if (calcWrap) calcWrap.style.display = 'none';
    }

    renderTable();
    setupScrollArrow();

    /* ---------- calculator ---------- */
    function bandFromUnderbust(u){
      for (var i = 0; i < underbustRanges.length; i++){
        var r = underbustRanges[i];
        if (inRange(u, r.min, r.max)) return String(r.band);
      }
      return null;
    }
    function cupFromOverbust(band, b){
      var row = overbustByBand[band];
      if (!row) return null;
      // Only consider cups that actually EXIST in the matrix for this band,
      // so the calculator can never output an empty table cell (e.g. 38H).
      var validCups = cups.filter(function(c){ return row[c] && matrix[c] && matrix[c][band] != null; });
      if (!validCups.length) return null;
      // Exact range match among valid cups
      for (var i = 0; i < validCups.length; i++){
        var rng = row[validCups[i]];
        if (inRange(b, rng[0], rng[1])) return validCups[i];
      }
      // Out of range -> clamp to the nearest available cup for this band
      var first = validCups[0], last = validCups[validCups.length - 1];
      if (b < row[first][0]) return first;
      if (b > row[last][1]) return last;
      // Falls in a gap -> nearest by range center
      var best = null, bestDist = Infinity;
      validCups.forEach(function(c){
        var center = (row[c][0] + row[c][1]) / 2;
        var d = Math.abs(b - center);
        if (d < bestDist){ bestDist = d; best = c; }
      });
      return best;
    }
    function resultFor(band, cup){
      if (output === 'mapped'){
        return (matrix[cup] && matrix[cup][band]) ? matrix[cup][band] : (band + cup);
      }
      return band + cup;
    }

    function setupCalculator(){
      var st1 = root.querySelector('[data-step="1"]');
      var st2 = root.querySelector('[data-step="2"]');
      var st3 = root.querySelector('[data-step="3"]');
      if (!st1 || !st2 || !st3) return;
      var underbustInput = st1.querySelector('[data-field="underbust"]');
      var bustInput = st2.querySelector('[data-field="bust"]');
      var next1 = st1.querySelector('[data-action="next"]');
      var calc2 = st2.querySelector('[data-action="calc"]');
      var outSize = st3.querySelector('[data-out="size"]');
      var restart = st3.querySelector('[data-action="restart"]');
      if (!underbustInput || !bustInput || !next1 || !calc2) return;

      if (underbustRanges.length){
        var uMin = Math.min.apply(null, underbustRanges.map(function(r){ return r.min; }));
        var uMax = Math.max.apply(null, underbustRanges.map(function(r){ return r.max; }));
        underbustInput.min = uMin; underbustInput.max = uMax;
      }
      var all = [];
      Object.keys(overbustByBand).forEach(function(b){
        var row = overbustByBand[b];
        Object.keys(row).forEach(function(c){ all.push(row[c][0]); all.push(row[c][1]); });
      });
      if (all.length){ bustInput.min = Math.min.apply(null, all); bustInput.max = Math.max.apply(null, all); }

      function show(stepEl){ st1.hidden = true; st2.hidden = true; st3.hidden = true; stepEl.hidden = false; }
      function validUnderbust(){ return !!bandFromUnderbust(Number(underbustInput.value)); }
      function validBust(){
        var band = bandFromUnderbust(Number(underbustInput.value));
        if (!band) return false;
        return !!cupFromOverbust(band, Number(bustInput.value));
      }
      function calc(){
        var band = bandFromUnderbust(Number(underbustInput.value));
        if (!band){ alert('Underbust measurement is outside of the chart range.'); return; }
        var cup = cupFromOverbust(band, Number(bustInput.value));
        if (!cup){ alert('Bust measurement does not match this underbust band size.'); return; }
        outSize.textContent = resultFor(band, cup);
        show(st3);
      }

      underbustInput.addEventListener('input', function(){ next1.disabled = !validUnderbust(); });
      bustInput.addEventListener('input', function(){ calc2.disabled = !validBust(); });
      underbustInput.addEventListener('keydown', function(e){ if (e.key === 'Enter' && !next1.disabled){ e.preventDefault(); show(st2); } });
      bustInput.addEventListener('keydown', function(e){ if (e.key === 'Enter' && !calc2.disabled){ e.preventDefault(); calc(); } });
      next1.addEventListener('click', function(){ show(st2); });
      calc2.addEventListener('click', calc);
      if (restart){
        restart.addEventListener('click', function(){
          underbustInput.value = ''; bustInput.value = '';
          next1.disabled = true; calc2.disabled = true;
          if (outSize) outSize.textContent = '—';
          show(st1);
        });
      }
    }

    /* ---------- table ---------- */
    function renderTable(){
      var container = root.querySelector('[data-sgc-table]');
      if (!container) return;
      var h = '<table class="sgc-table"><thead><tr>';
      h += '<th class="sgc-cup-header"><div class="sgc-cup-label"><div>Cups</div>' + CUP_DOWN_SVG + '</div></th>';
      bands.forEach(function(b){ h += '<th>' + esc(b) + '</th>'; });
      h += '</tr></thead><tbody>';
      cups.forEach(function(cup){
        h += '<tr><td class="sgc-cup-size">' + esc(cup) + '</td>';
        bands.forEach(function(band){
          var val = (matrix[cup] && matrix[cup][band]) ? matrix[cup][band] : '';
          if (val){
            var bg = colors[val] || '#ffffff';
            h += '<td style="background-color:' + esc(bg) + ';">' + esc(val) + '</td>';
          } else {
            h += '<td></td>';
          }
        });
        h += '</tr>';
      });
      h += '</tbody></table>';
      container.innerHTML = h;
    }

    /* ---------- scroll arrow ---------- */
    function setupScrollArrow(){
      var wrapper = root.querySelector('.sgc-chart-wrapper');
      var arrow = root.querySelector('.sgc-scroll-arrow');
      if (!wrapper || !arrow) return;
      function update(){
        if (wrapper.scrollLeft + wrapper.clientWidth < wrapper.scrollWidth){
          arrow.innerHTML = CHEVRON_RIGHT; arrow.style.right = '10px'; arrow.style.left = 'auto';
        } else {
          arrow.innerHTML = CHEVRON_LEFT; arrow.style.left = '10px'; arrow.style.right = 'auto';
        }
      }
      update();
      wrapper.addEventListener('scroll', update);
      window.addEventListener('resize', update);
      arrow.addEventListener('click', function(){
        var atEnd = wrapper.scrollLeft + wrapper.clientWidth >= wrapper.scrollWidth - 1;
        wrapper.scrollTo({ left: atEnd ? 0 : wrapper.scrollWidth, behavior: 'smooth' });
      });
    }
  }

  function initSizeGuideCombined(scope){
    scope = scope || document;
    if (scope.nodeType === 1 && scope.matches && scope.matches('[data-sgc-root]')) initRoot(scope);
    var roots = scope.querySelectorAll ? scope.querySelectorAll('[data-sgc-root]') : [];
    Array.prototype.forEach.call(roots, initRoot);
  }

  window.initSizeGuideCombined = initSizeGuideCombined;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){ initSizeGuideCombined(document); });
  } else {
    initSizeGuideCombined(document);
  }
})();
